import { Text } from "@mantine/core";

import type { SalesOpportunitiesMetricsView } from "../data/types";

import salesOpportunitiesIcon from "./assets/salesOpportunitiesIcon.png";
import styles from "./cardContent.module.css";
import { computeDirectRingFill, computeMetricStatus } from "./computeRingFill";
import { MetricCard } from "./MetricCard";
import { RingArt } from "./RingArt";
import { SALES_OPPORTUNITIES_GRADIENT, SALES_TARGET } from "./targets";

interface Props {
    view: SalesOpportunitiesMetricsView;
}

export function SalesOpportunitiesCard({ view }: Props) {
    const sales = view.sales;
    const hasSales = sales !== null;
    const ringProgress = hasSales ? computeDirectRingFill(sales, SALES_TARGET) : 0;
    const targetUnit = SALES_TARGET === 1 ? "sale" : "sales";
    const status = hasSales ? computeMetricStatus(ringProgress) : undefined;
    const delta = hasSales
        ? `${Math.abs(sales - SALES_TARGET)} ${sales >= SALES_TARGET ? "above" : "below"} target`
        : undefined;

    return (
        <MetricCard
            title="Sales and opportunities"
            isLoading={view.isLoading}
            isEmpty={!hasSales}
            emptyValue="No sales data yesterday."
            art={
                <RingArt progress={ringProgress} gradient={SALES_OPPORTUNITIES_GRADIENT} isLoading={view.isLoading}>
                    <img src={salesOpportunitiesIcon} alt="" className={styles.icon} />
                </RingArt>
            }
            value={
                <Text component="span" className={styles.bigNumber}>
                    {sales}
                </Text>
            }
            footer={
                <>
                    {SALES_TARGET} {targetUnit}
                </>
            }
            status={status}
            delta={delta}
        />
    );
}
